import _sum from 'lodash/sum'
import _isUndefined from 'lodash/isUndefined'

import { type Emissions, type EmissionsGroup } from 'types/data'

const getSelectedEmissionGroups = (
  groups: EmissionsGroup[],
  selectedEmissions: Emissions[]
): EmissionsGroup[] =>
  groups.filter(
    ({ polygons }: { polygons: Emissions[] }) =>
      _sum(
        polygons.map((emissions: Emissions) =>
          _isUndefined(selectedEmissions.find(({ id }) => id === emissions.id))
            ? 0
            : 1
        )
      ) === polygons.length
  )

export default getSelectedEmissionGroups
